import { render, staticRenderFns } from "./SimpleManager.vue?vue&type=template&id=25fead9a&scoped=true&"
import script from "./SimpleManager.vue?vue&type=script&lang=js&"
export * from "./SimpleManager.vue?vue&type=script&lang=js&"
import style0 from "./SimpleManager.vue?vue&type=style&index=0&id=25fead9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fead9a",
  null
  
)

export default component.exports